import { ca } from '@cian/analytics';

export function trackingFavoritesIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'favorites',
  });
}
